export {
    CompetitionScoreCard,
    CompetitionScoreCard as default,
} from './CompetitionScoreCard'
